module.exports = __webpack_public_path__ + "assets/pdf/resume_Heri.b0f65955.pdf";